import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import ReverseRelevanceList from "./reverse-relevance-list.vue";
import ReverseRelevanceTabs from "./reverse-relevance-tabs.vue";
// import { ReverseRelevanceControl } from "../../../controls";
import { ReverseRelevanceControl } from "@cloudpivot/form/src/common/controls/reverse-relevance-control";
import common from '@cloudpivot/common/pc';
let ReverseRelevance = class ReverseRelevance extends ReverseRelevanceControl {
};
ReverseRelevance = tslib_1.__decorate([
    Component({
        name: "reverse-relevance",
        components: {
            ReverseRelevanceList,
            ReverseRelevanceTabs,
            H3Panel: common.components.Panel,
        }
    })
], ReverseRelevance);
export default ReverseRelevance;
